module.exports = __webpack_public_path__ + "img/bg_slide_2.a15154b2.png";